import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class PinterestShare extends PureComponent {
    trackShare = () => {
        if( this.props.trackShare ) {
            this.props.trackShare( 'pinterest' );
        }
    }
    render() {
        let queryStr = Object.encodeURLQuery( {
            url: window.location.href,
            media: this.props.img,
            description: this.props.description,
        } );
        let href = 'https://www.pinterest.com/pin/create/button/' + queryStr;
        return (
            <div className={ style.pinterestShare } onClick={ this.trackShare } style={ this.props.style } >
                <a data-pin-do='buttonPin' data-pin-tall='true' data-pin-round='true' href={ href } target='_blank' rel='noopener noreferrer'>
                    <Icon source='fontAwesome' icon='fab/faPinterest' alt='Pinterest Share' size={ null } />
                </a>
            </div>
        );
    }
}
PinterestShare.defaultProps = {
    img: null,
};
PinterestShare.propTypes = {
    img: PropTypes.string,
};


export default connect()( PinterestShare );
